module.exports = __webpack_public_path__ + "static/media/hang_finger.ed436361.svg";